import React from 'react';
import styled from 'styled-components';
import MenuItem, { Props as MenuItemProps } from 'ui/atoms/MenuItem/MenuItem';
import Separator from 'ui/atoms/Separator/Separator';

const StyledNav = styled.nav`
  box-shadow: inset 0 0.25rem 0.625rem rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  margin: 0 auto;
  padding: 2rem 1.5rem 1.125rem 1.5rem;
  background: ${(props) => props.theme.colors.bgDark};
`;

export interface Props {
  items: MenuItemProps[];
  isAdmin: boolean;
  isEntraLess: boolean;
}

const getAccessEventsIndex = (isAdmin: boolean, isEntraLess: boolean) => {
  if (isAdmin)
    if (isEntraLess) return 0;
    else return 1;
  else return undefined;
};

const SideNav: React.FC<React.PropsWithChildren<Props>> = ({ items, isAdmin, isEntraLess }) => {
  const accessEventsIndex = getAccessEventsIndex(isAdmin, isEntraLess);
  return (
    <StyledNav>
      {items.map(({ icon, text, location, isSelected }, index) =>
        accessEventsIndex !== undefined && accessEventsIndex === index ? (
          <div key={`SideNavItem-${location}`}>
            <Separator height="0.5rem" />
            <MenuItem key={location} icon={icon} text={text} location={location} isSelected={isSelected} />
            <Separator height="0.5rem" />
          </div>
        ) : (
          <MenuItem key={location} icon={icon} text={text} location={location} isSelected={isSelected} />
        )
      )}
    </StyledNav>
  );
};

export default SideNav;
